import {
  ArrowsLeftRight,
  Triangle,
  ChartLineUp,
  Graph,
  Lightning,
  ChartBar,
  Cpu,
  SlidersHorizontal,
  Brain,
  StackSimple,
  MagnifyingGlass,
  Gauge,
  ShieldCheck,
  Database,
  Cube,
  Lock,
  Eye,
  Key,
  Fingerprint,
  Bell,
  ClipboardText,
  Broadcast,
  Circuitry,
} from "@phosphor-icons/react";

export const ICONS = {
  ArrowsLeftRight,
  Triangle,
  ChartLineUp,
  Graph,
  Lightning,
  ChartBar,
  Cpu,
  SlidersHorizontal,
  Brain,
  StackSimple,
  MagnifyingGlass,
  Gauge,
  ShieldCheck,
  Database,
  Cube,
  Lock,
  Eye,
  Key,
  Fingerprint,
  Bell,
  ClipboardText,
  Broadcast,
  Circuitry,
};

export function Icon({ name, ...props }) {
  const Cmp = ICONS[name] || Cube;
  return <Cmp {...props} />;
}
